import { Table, Tooltip } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import type { ModelUsageItem, UsageBreakdownItem } from '../../api/usage';
import { renderCredits, renderToken } from './format';

interface Props<T extends UsageBreakdownItem> {
  rows: T[];
  loading?: boolean;
  showTenantCount?: boolean;
  onInspectTenants?: (row: T) => void;
}

export function UsageBreakdownTable<T extends UsageBreakdownItem>({
  rows,
  loading,
  showTenantCount,
  onInspectTenants,
}: Props<T>) {
  const columns: ColumnsType<T> = [
    { title: '模型', dataIndex: 'model', key: 'model', width: 320, ellipsis: true },
    { title: '供应商', dataIndex: 'providerLabel', key: 'providerLabel', width: 140, ellipsis: true },
    { title: '缓存命中', key: 'cacheRead', width: 140, render: (_, row) => renderToken(row.cacheReadTokens) },
    {
      title: '缓存未命中', key: 'cacheMiss', width: 160,
      render: (_, row) => (
        <Tooltip title={<>输入总量：{renderToken(row.inputTotalTokens)}</>}>
          <span tabIndex={0}>{renderToken(row.cacheMissTokens)}</span>
        </Tooltip>
      ),
    },
    { title: '输出', key: 'output', width: 140, render: (_, row) => renderToken(row.outputTokens) },
    { title: '期间积分', key: 'credits', width: 140, render: (_, row) => renderCredits(row.creditsUsed) },
  ];
  if (showTenantCount) {
    columns.push({ title: '租户数', dataIndex: 'tenantCount', key: 'tenantCount', width: 90 });
    columns.push({
      title: '操作',
      key: 'actions',
      width: 120,
      render: (_, row) => (
        <button type="button" className="btn btn-ghost btn-sm" onClick={() => onInspectTenants?.(row)}>
          查看租户
        </button>
      ),
    });
  }
  return (
    <Table<T>
      className="usage-table"
      rowKey={(row) => `${row.providerKey}:${row.model}`}
      columns={columns}
      dataSource={rows}
      loading={loading}
      pagination={false}
      scroll={{ x: showTenantCount ? 1250 : 1040 }}
      size="small"
    />
  );
}

export type { ModelUsageItem };
